module.exports = __webpack_public_path__ + "assets/CreateDeal.56a26c4f.svg";